import { Capacitor } from '@capacitor/core'
import { useMemo } from 'react'

interface IProps {
  web: any
  mobile: any
}

export const usePlatformSwitcher = ({ web, mobile }: IProps) => {
  const obj = useMemo(() => {
    if (!Capacitor.isNativePlatform()) {
      return web
    }

    return mobile
  }, [])

  return obj
}
